/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CheckFileExistsResult } from '../../models/check-file-exists-result';

export interface ApiFilesFileIdExistsGet$Params {
  fileId: string;
}

export function apiFilesFileIdExistsGet(http: HttpClient, rootUrl: string, params: ApiFilesFileIdExistsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CheckFileExistsResult>> {
  const rb = new RequestBuilder(rootUrl, apiFilesFileIdExistsGet.PATH, 'get');
  if (params) {
    rb.path('fileId', params.fileId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CheckFileExistsResult>;
    })
  );
}

apiFilesFileIdExistsGet.PATH = '/api/files/{fileId}/exists';
